module.exports = __webpack_public_path__ + "img/fedex-logo-official.85a80f0b.svg";